import isServer from '@lyra/core/utils/isServer'
import { useMemo } from 'react'

import { Instrument } from '../constants/instruments'
import { getDefaultExpiry, getUniqueExpiries } from '../utils/instruments'
import useSelectedExpiry from './useSelectedExpiry'

export default function useSelectedExpiryWithDefault(
  instruments: Instrument[]
): [Date | undefined, (expiry: Date) => void] {
  const expiries: Date[] = useMemo(() => getUniqueExpiries(instruments), [instruments])

  // Default to selected instrument expiry, then most recent expiry
  const defaultExpiry = useMemo(() => getDefaultExpiry(expiries), [expiries])

  const [_queryExpiry, setQueryExpiry] = useSelectedExpiry()
  const queryExpiry = useMemo(
    () =>
      _queryExpiry && expiries.find((expiry) => expiry.getTime() === _queryExpiry.getTime())
        ? _queryExpiry
        : null,
    [expiries, _queryExpiry]
  )

  // HACK: We need access to default expiry for ssr
  const selectedExpiry = isServer ? defaultExpiry : queryExpiry ? queryExpiry : defaultExpiry

  return useMemo(() => [selectedExpiry, setQueryExpiry], [selectedExpiry, setQueryExpiry])
}
